<template>
	<div class="wrapper-area scroll-color" v-scroll-paginate="scrollHandler" ref="reserve-wrapper-list">
		<div class="infos" v-if="loading">
			<ui-load-indicator bgColor="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
		</div>

		<div class="infos" v-if="reserveList && !reserveList.length && !loading">
			<div class="title">
				<div v-if="!info">Nenhuma unidade foi encontrada.</div>
				<div v-else>{{ info }}</div>
			</div>
		</div>

		<div class="wrapper-list" v-if="reserveList && reserveList.length && !loading">
			<div
				class="item"
				v-for="reserve in reserveList"
				:key="reserve.id"
				:class="{ 'item-cursor-block': reserve.permission_action == 0 || reserve.permission_action == false }"
			>
				<reserve-wrapper :reserve="reserve" :checked="reserve.check" v-model="selected" />
			</div>
		</div>
	</div>
</template>

<script>
	import { uiLoadIndicator } from '@/components/ui'
	import { scrollPaginate } from '@/directives'
	import ReserveWrapper from './components/reserve-wrapper/index.vue'

	export default {
		name: 'reserve-wrapper-list',

		components: { ReserveWrapper, uiLoadIndicator },

		directives: { scrollPaginate },

		props: {
			value: {
				type: Array,
				default: () => [],
			},

			loading: {
				type: Boolean,
				default: false,
			},

			info: {
				type: String,
				default: '',
			},
		},

		data() {
			return {
				selected: '',
				reserveList: [],
			}
		},

		mounted() {
			this.$emit('input', this.reserveList)
		},

		methods: {
			scrollHandler() {
				this.$emit('scroll')
			},
		},

		watch: {
			value(value) {
				this.selected = ''
				this.reserveList = value
			},

			selected: {
				handler(value) {
					this.reserveList.map((reserve) => {
						const currentData = `${reserve.id} ${reserve.description}`

						if (currentData == value) {
							reserve.check = true
							return
						}

						reserve.check = false
					})
				},

				deep: true,
			},

			reserveList: {
				handler(value) {
					this.$emit('input', value)
					this.$nextTick(() => {
						this.reserveList.map((reserve, key) => {
							if (reserve.check) {
								const el = this.$refs['reserve-wrapper-list']
								el.scrollTo(0, 60 * key)
							}
						})
					})
				},
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
